export default __webpack_public_path__ + "static/media/icon-Table-Down-Chevron.db964758.svg";